// This helper splits the array to 2D array
export const splitArray = (array: any[], part: number) => {
  const tmp = [];
  for (let i = 0; i < array.length; i += part) {
    tmp.push(array.slice(i, i + part));
  }
  return tmp;
};

/**
 * Simple function to create an array of incrementing numbers [0, 1, 2...]]
 */
export const buildIndexedArray = (numberOfIndexes: number) =>
  Array.from({ length: numberOfIndexes }).map((_, idx) => idx);

/**
 * Breaks an array into chunks of a given size.
 */
export const chunkArray = <T>(array: T[], chunkSize: number): T[][] => {
  if (chunkSize <= 0) throw new Error('Chunk size must be greater than 0');

  const chunkedArray = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunkedArray.push(array.slice(i, i + chunkSize));
  }
  return chunkedArray;
};
